import React, {PropTypes} from 'react';
import '../../styles/header/header.css';
import BreadCrumb from './BreadCrumb.js';
import Menu from './Menu.js';
import * as formNames from '../../constants/formNameConstants';

const Header = ({
  authenticated,
  pageName,
  parent,
  menuTitleShown,
  user,
  logout,
  onNavChange
}) => {
  return (
    <div className="header-div">
      <div className="breadcrumb-container">
        <BreadCrumb pageName={pageName} parent={parent}/>
      </div>
      <Menu
        authenticated={authenticated}
        user={user}
        logout={logout}
        onNavChange={onNavChange}
        menuTitleShown={menuTitleShown}/>
      <div className="pagetitle-container col-xs-12 col-sm-5">
        <div className="pagetitle">
          {pageName == formNames.itaLoginPage ?
            null :
            <h2>{pageName}</h2>
          }
        </div>
      </div>
    </div>

  );
};

Header.propTypes = {
  authenticated: PropTypes.bool.isRequired,
  user: PropTypes.object,
  pageName: PropTypes.string,
  parent: PropTypes.object.isRequired,
  menuTitleShown: PropTypes.bool.isRequired,
  onNavChange: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired
};

export default Header;



/** WEBPACK FOOTER **
 ** ./src/components/common/Header.js
 **/